// components
import { styled } from '@mui/material';
import { ControlledTextField } from 'components/shared/ControlledFields';

export const StyledTextFieldWithMarginTop = styled(ControlledTextField)(
  ({ theme }) => ({
    marginTop: theme.spacing(2)
  })
);
